import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ResponseModel } from "src/app/shared/interfaces/response-model";
import {
    IClientDocument,
    IPendingClientRequestDocument,
    IReviewClientDocument,
    IUploadClientDocument
} from "../models/client-document.model";

@Injectable({
    providedIn: 'root'
})
export class ClientDocumentService {
    private http = inject(HttpClient);
    private readonly baseUrl = `${environment.cmsBaseUrl}/api/${environment.anqCmsVersion}/ClientDocument`;
    
    uploadClientDocument(clientId: string, payload: IUploadClientDocument): Observable<ResponseModel<string>> {
        const formData = new FormData();
        formData.append('DocumentFile', payload.file, payload.file.name);
        formData.append('DocumentType', String(payload.documentType));

        let params = new HttpParams();
        if (clientId) params = params.set('clientId', clientId);

        return this.http.post<ResponseModel<string>>(`${this.baseUrl}/UploadDocument`, formData, { params });
    }
    
    reviewClientDocument(
        query: { 
            documentType: number; 
            status: number; 
            clientId: string 
        }, 
        payload: IReviewClientDocument
    ): Observable<ResponseModel<string>> {
        let params = new HttpParams();
        if (query.clientId) params = params.set('clientId', query.clientId);
        if (query.documentType) params = params.set('documentType', query.documentType.toString());
        if (query.status) params = params.set('status', query.status.toString());

        return this.http.put<ResponseModel<string>>(`${this.baseUrl}/ReviewDocument`, payload, { params });
    }

    getReviewPendingRequest(): Observable<IPendingClientRequestDocument[]> {
        return this.http.get<IPendingClientRequestDocument[]>(`${this.baseUrl}/ReviewPendingRequest`);
    }

    getClientDocuments(clientId: string): Observable<IClientDocument> {
        return this.http.get<IClientDocument>(`${this.baseUrl}/GetClientDocuments`, {
            params: new HttpParams().set('clientId', clientId)
        });
    }

    viewDocument(clientId: string, documentType: number) {
        return `${this.baseUrl}/ViewDocument?clientId=${clientId}&documentType=${documentType}`;
    }

    replaceClientDocument(clientId: string, payload: IUploadClientDocument): Observable<ResponseModel<string>> {
        const formData = new FormData();
        formData.append('DocumentFile', payload.file, payload.file.name);
        formData.append('DocumentType', String(payload.documentType));

        let params = new HttpParams();
        if (clientId) params = params.set('clientId', clientId);

        return this.http.put<ResponseModel<string>>(`${this.baseUrl}/ReplaceDocument`, formData, { params });
    }

    deleteClientDocument(clientId: string, documentType: number): Observable<ResponseModel<string>> {
        let params = new HttpParams();
        if (clientId) params = params.set('clientId', clientId);
        if (documentType) params = params.set('documentType', documentType.toString());

        return this.http.delete<ResponseModel<string>>(`${this.baseUrl}/DeleteDocument`, { params });
    }

}
